export default "__VITE_ASSET__4748c289__"